import React from 'react';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import MergeIcon from '@mui/icons-material/Merge';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

interface CriterionActionButtonsProps {
  selectedCriteria: Set<string>;
  selectedOperators: Set<string>;
  selectedCompoundOperators: Set<string>;
  onAddCriterion: () => void;
  onInvertSelected: () => void;
  onCombineClick: () => void;
  onRemoveSelected: () => void;
  simplified?: boolean;
}

export const CriterionActionButtons: React.FC<CriterionActionButtonsProps> = ({
  selectedCriteria,
  selectedOperators,
  selectedCompoundOperators,
  onAddCriterion,
  onInvertSelected,
  onCombineClick,
  onRemoveSelected,
  simplified = false,
}) => {
  const isSmall = useIsSmallScreen();

  const selectedItemsCount =
    (selectedOperators?.size ?? 0) +
    (selectedCriteria?.size ?? 0) +
    (selectedCompoundOperators?.size ?? 0);

  const hasMultipleSelections = selectedItemsCount > 1;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Button
        variant={isSmall ? 'contained' : 'contained'}
        sx={{
          '.MuiButton-startIcon': {
            marginRight: '0px !important',
          },
        }}
        onClick={onAddCriterion}
        startIcon={
          <AddIcon
            fontSize="small"
            sx={{
              marginRight: 0,
            }}
          />
        }
      >
        {isSmall ? 'Add' : 'Criterion'}
      </Button>
      {!simplified && selectedItemsCount === 1 && (
        <Button
          variant={isSmall ? 'text' : 'outlined'}
          onClick={() => onInvertSelected()}
        >
          {isSmall ? 'Invert' : 'Invert Selected'}
        </Button>
      )}
      {!simplified && hasMultipleSelections && (
        <Button
          variant={isSmall ? 'text' : 'outlined'}
          sx={{
            '.MuiButton-startIcon': {
              marginRight: '0px !important',
            },
          }}
          startIcon={<MergeIcon />}
          onClick={onCombineClick}
        >
          Combine
        </Button>
      )}
      {selectedItemsCount > 0 && (
        <Button
          variant={isSmall ? 'text' : 'outlined'}
          sx={{
            '.MuiButton-startIcon': {
              marginRight: '0px !important',
            },
          }}
          color="error"
          onClick={onRemoveSelected}
          startIcon={<DeleteIcon />}
        >
          {isSmall ? 'Remove' : 'Remove Selected'}
        </Button>
      )}
    </Box>
  );
};
